import { L10nModule } from 'bernie-l10n';

export function localization(locale: string): L10nModule {
  const mod = new L10nModule();

  mod.current = locale;
  // eslint-disable-next-line @typescript-eslint/no-require-imports,import/no-dynamic-require
  mod.globalize = require(`shopping-pwa-localization/dist/bundle-${locale}`);

  return mod;
}
